import { StyleSheet } from "aphrodite";

const Style = StyleSheet.create({
  subscriptionContainerMainContaine: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      gap: "20px",
    },
    subscriptionContainer: {
      marginTop: "10px",
      boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.05)",
      borderRadius: "8px",
      background: "#fff",
      "@media (max-width: 768px)": {
        boxShadow: "none",
      },
    },
  },
});

export default Style;
